import { render, staticRenderFns } from "./PItemRow2-6.vue?vue&type=template&id=2b3e82f1"
import script from "./PItemRow2-6.vue?vue&type=script&lang=js"
export * from "./PItemRow2-6.vue?vue&type=script&lang=js"
import style0 from "./PItemRow2-6.vue?vue&type=style&index=0&id=2b3e82f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports